import { NavLink } from 'react-router-dom';

export interface TabDef {
  to: string;
  label: string;
  end?: boolean;
}

export const TABS: TabDef[] = [
  { to: '/website', label: 'Overview', end: true },
  // Second, next to Overview: it is the only tab whose numbers change while you watch, and the one
  // people open to check whether a change just shipped is working.
  { to: '/live', label: 'Live' },
  // Leads is deliberately NOT here. It is about people and money rather than page traffic, it has
  // its own sub-views and a per-lead page, and it reads a different table — so it sits in the
  // sidebar beside Accounts, which is the other non-traffic domain.
  { to: '/domains', label: 'Domains' },
  { to: '/journeys', label: 'Journeys' },
  // Beside Journeys, because the two are halves of one question: Journeys says which route was
  // walked, Behaviour says how long it took and how it ended.
  { to: '/behaviour', label: 'Behaviour' },
  { to: '/acquisition', label: 'Acquisition' },
  { to: '/geography', label: 'Geography' },
  { to: '/insights', label: 'Insights' },
  { to: '/pages', label: 'Pages' },
  { to: '/frustration', label: 'Frustration' },
];

/** Tab strip. Uses existing tokens only — no new colours enter the system here. */
export function TabNav() {
  return (
    <nav className="tabnav" aria-label="Analytics sections">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) => `tabnav-item${isActive ? ' active' : ''}`}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
